const ExtraCreditMain ="You have successfully completed the <InsertChallengeName> challenge."
export default ExtraCreditMain